import React from "react"
import {
  Container,
  List,
  FooterLogo,
  SocialListItem,
  FooterLink
} from "./elements"
import { Flex } from "../Flex"
import { Box, Flex as FlexBox } from "reflexbox/styled-components"
import { useTranslation } from "react-i18next"
import ListItem from "./ListItem"
import {
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  WhatsappIcon,
  EmailIcon
} from "./icons"

import logo from "../../img/muv-logo.svg"
import roundedLogo from "../../../static/img/footer/logo-round.svg"
import appStoreLogo from "../../../static/img/footer/appstore.svg"
import playStoreLogo from "../../../static/img/footer/playstore.svg"
import TranslateComponentItem from "./TranslateComponentItem"
import Collapsible from "react-collapsible"
import ListHeader from "./ListHeader"

export const FooterContext = React.createContext({ secondary: false })

const Footer = ({ secondary }) => {
  const { t } = useTranslation()
  return (
    <FooterContext.Provider value={{ secondary }}>
      <Container gradient={secondary}>
      <Flex mx={-2} sx={{ color: "text" }}>
        <div></div>
        <FlexBox py={["112px"]} mt={["4rem"]} width={['100%']} justifyContent="center">
          <Box 
            px={4}
            style={{
              textAlign: "center",
            }}
          >
            <FooterLogo src={secondary ? logo : roundedLogo} alt="logo" />
          </Box>
          <Box  px={4}>
            <List>
              <FooterLink to="/driver">
                <ListItem title={t("driver")} />
              </FooterLink>
              <FooterLink to="/more">
                <ListItem title={t("findMore")} />
              </FooterLink>
              <FooterLink to="/join">
                <ListItem title={t("join")} />
              </FooterLink>
              <FooterLink to="/contact">
                <ListItem title={t("contact")} />
              </FooterLink>
              <FooterLink to="/corporate">
                <ListItem title={t("corporate")} />
              </FooterLink>
              <Box pt={"1rem"}>
                <TranslateComponentItem />
              </Box>
            </List>
          </Box>
          <Box  px={4}>
            <List>
              <FooterLink to="/help-center">
                <ListItem title={t("help")} />
              </FooterLink>
              {/* <FooterLink to="/benefits">
                <ListItem title={t("benefits")} />
              </FooterLink> */}
              <Collapsible
                transitionTime={200}
                trigger={<ListHeader title={t("terms")}/>}
                triggerWhenOpen={<ListHeader title={t("terms")} open={true}/>}
              >
                <List style={{paddingTop: '15px'}}>
                  <FooterLink to="/terms-drivers">
                    <ListItem subitem={true} title={t("drivers")} />
                  </FooterLink>
                  <FooterLink to="/terms-users">
                    <ListItem subitem={true} title={t("passengers")} />
                  </FooterLink>
                </List>
              </Collapsible>
              <FooterLink to="/policies">
                <ListItem title={t("policies")} />
              </FooterLink>
            </List>
          </Box>
          <Box  px={4} pt={"2rem"}>
            <List>
              <SocialListItem>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/py/app/muv/id1254658756"
                >
                  <img src={appStoreLogo} alt="appStore" />
                </a>
              </SocialListItem>
              <SocialListItem>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.muv.customer&hl=es_PY"
                >
                  <img src={playStoreLogo} alt="playStore" />
                </a>
              </SocialListItem>
              <SocialListItem>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://twitter.com/app_muv"
                >
                  <TwitterIcon />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/app.muv"
                >
                  <FacebookIcon />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/app.muv/?hl=es-la"
                >
                  <InstagramIcon />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://api.whatsapp.com/send?phone=595971688688"
                >
                  <WhatsappIcon />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:info@muv-app.co"
                >
                  <EmailIcon />
                </a>
                <img alt="" />
              </SocialListItem>
            </List>
          </Box>
          </FlexBox>
        </Flex>
      </Container>
      </FooterContext.Provider>
  )
}

export default Footer
